<template>
    <div>
        <div v-if="!addAddress">
            <template v-if="addresses">
                <t-info-list-item v-for="address in addresses" :key="address.id" @click.native="onAddressSelected(address)" class="link">
                    <template v-slot:icon>
                        <i class="fas fa-2x fa-map-marker-alt"></i>
                    </template>

                    <template v-slot:title>
                        <template v-if="address.place">{{ address.place }}</template>
                        {{ address.address }}
                    </template>

                    <template v-slot:subtitle>
                        Piso y/o Unidad: {{ address.unit }} - Tel: {{ address.phone }} - Cel: {{ address.cellphone }}
                    </template>

                    <template v-slot:actions v-if="canDelete">
                        <span class="icon" @click="onDeleteClicked(address)"><i class="fas fa-trash-alt"></i></span>
                    </template>
                </t-info-list-item>
            </template>

            <t-info-list-item @click.native="onAddAddressClicked" class="link">
                <template v-slot:icon>
                    <i class="fas fa-2x fa-plus"></i>
                </template>

                <template v-slot:title>
                    <span>Agregar nueva dirección</span>
                </template>
            </t-info-list-item>
        </div>

        <div v-else>
            <delivery-address-create
                    @close="onCloseClicked"
                    @saved="onSaved"
            />
        </div>
    </div>
</template>

<script>
    import DeliveryAddressCreate from './DeliveryAddressCreate';
    import TInfoListItem from '../../components/ui/TInfoListItem';

    export default {
        name: 'DeliveryAddressList',

        props: {
            canSelect: {
                type: Boolean,
                default: false
            },
            canDelete: {
                type: Boolean,
                default: false
            }
        },

        components: {
            DeliveryAddressCreate,
            TInfoListItem
        },

        data() {
            return {
                addAddress: false,
                newAddress: null
            }
        },

        mounted() {
            if(!this.addresses || this.addresses.length === 0) {
                this.addAddress = true;
            }
        },

        computed: {
            canAdvance() {
                return true;
            },

            customer() {
                return this.$store.getters['customer/get']();
            },

            addresses() {
                return this.customer.shippingAddresses;
            }
        },

        methods: {
            onSaved(address) {
                this.$emit('input', address);

                this.addAddress = false;
            },

            onAddressSelected(address) {
                this.$emit('input', address);
            },

            onAddAddressClicked() {
                this.addAddress = true;
            },

            onCloseClicked() {
                this.addAddress = false;
            },

            onDeleteClicked(address) {
                this.$buefy.dialog.confirm({
                    title: 'Eliminar dirección',
                    message: 'Esta seguro que quiere eliminar la siguiente direccion?' + '<p>' + address.address + '</p>',
                    confirmText: 'Eliminar',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {
                        return this.$store.dispatch('customer/removeShippingAddress', address).then(() => {
                            this.$toast.open('Dirección eliminada');
                        })
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    th {
        text-transform: capitalize;
    }

    .modal-content {
        width: 800px;
    }

    .modal-footer {
        margin-top: 40px;
    }
</style>